<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" slim>
    <form @submit.prevent="handleSubmit(checkForEndDate)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <ValidationProvider
            tag="div" class="form-group col-lg-4 col-md-12"
            rules="required"
            name="gebruiker" v-slot="{ errors }">
          <label for="user">Gebruiker</label>
          <select
              id="user"
              class="form-control"
              v-model="selectedUserId">
            <option :value="undefined" disabled>Kies een gebruiker</option>
            <option
                :key="user.id" :value="user.id"
                v-for="user in getUsersSorted()">
              {{ user.email }}
            </option>
          </select>
          <span class="text-red">{{ errors[0] }}</span>
        </ValidationProvider>

        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="startDate"
            labelText="startdatum" required
            vid="startDate" :crossFieldRules="['same_or_before_field:@endDate']"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="endDate"
            labelText="einddatum"
            vid="endDate" :crossFieldRules="['same_or_after_field:@startDate']"/>

        <div class="form-group col-lg-12">
          <label>Interne Referentie</label>
          <textarea class="form-control" id="textarea" rows="2" v-model="reference" maxlength="255"></textarea>
        </div>

        <h6 class="display-4 form-group col-lg-12 mt-3" style="font-size: 1.5em;">Order</h6>

        <NumberInputField
            class="form-group col-lg-4 col-md-12"
            labelText="uurtarief" required
            id="uurtarief"
            step=".01"
            v-model="order.baseHourlyRate"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="order.startDate"
            labelText="Order startdatum" required
            vid="hourlyRateStartDate"
            :crossFieldRules="['same_or_before_field:@hourlyRateEndDate', 'same_or_after_field:@startDate', 'same_or_before_field:@endDate']"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="order.endDate"
            labelText="Order einddatum" required
            vid="hourlyRateEndDate"
            :crossFieldRules="['same_or_after_field:@hourlyRateStartDate', 'same_or_before_field:@endDate']"/>
        <TextInputField class="form-group col-lg-12" labelText="Interne referentie" id="textarea" rows="2" v-model="order.internalReference" maxlength="255"></TextInputField>
        <TextInputField class="form-group col-lg-12" labelText="Externe referentie" id="textarea" rows="2" v-model="order.externalReference" maxlength="255"></TextInputField>
      </div>

      <div class="form-row align-items-center">
        <div class="input-group col-6">
          <button
              type="submit" :disabled="invalid"
              class="btn-basic btn-fill-pulse">
            Opslaan
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import DateInputField from "@/components/inputFields/DateInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";
import TextInputField from "@/components/inputFields/TextInputField";

export default {
  name: "CreateContractFromCustomerComponent",
  components: {
    NumberInputField,
    DateInputField,
    ValidationProvider,
    ValidationObserver,
    TextInputField
  },
  props: ['customerId'],
  data() {
    return {
      selectedUserId: undefined,
      startDate: "",
      endDate: "",
      order: {
        startDate: "",
        endDate: "",
        baseHourlyRate: undefined,
        internalReference: "",
        externalReference: ""
      },
    };
  },
  computed: {
    ...mapGetters({
      usersMinimalInfo: "administrationUser/usersMinimalInfo"
    }),
  },
  async created() {
    await this.fetchActiveUsers();
  },
  methods: {
    ...mapActions("administrationTimeSheet", ['createContract']),
    ...mapActions("administrationUser", ['fetchActiveUsers']),
    ...mapMutations({
      addContractToSelectedCustomerDetail: "administrationCustomer/addContractToSelectedCustomerDetail"
    }),
    checkForEndDate() {
      if (!(this.endDate === "")) {
        if (confirm("Een einddatum toevoegen of aanpassen aan een contract kan ertoe leiden dat alle ingevulde timesheets van dit contract na de einddatum weggesmeten worden. Ben je zeker dat je dit contract wil opslaan?")) {
          this.saveContract();
        }
      } else {
        this.saveContract();
      }
    },
    saveContract() {
      const createContractDto = {
        userId: this.selectedUserId,
        customerId: this.customerId,
        startDate: this.startDate,
        endDate: this.endDate,
        order: {
          startDate: this.order.startDate,
          endDate: this.endDate === null ? null : this.order.endDate,
          baseHourlyRate: this.order.baseHourlyRate,
          internalReference: this.order.internalReference,
          externalReference: this.order.externalReference
        }
      };
      this.createContract(createContractDto)
          .then(response => {
            this.addContractToSelectedCustomerDetail(response.data);
            this.resetFields();
            this.$emit('contractAdded');
          });
    },
    resetFields() {
      this.selectedUserId = undefined;
      this.startDate = "";
      this.endDate = "";
      this.order.startDate = "";
      this.order.endDate = "";
      this.order.baseHourlyRate = undefined;
      this.order.message = "";
    },
    getUsersSorted: function () {
      return [...this.usersMinimalInfo].sort((first, second) => {
        const emailFirst = first.email.toUpperCase();
        const emailSecond = second.email.toUpperCase();
        if (emailFirst < emailSecond) {
          return -1;
        }
        if (emailFirst > emailSecond) {
          return 1;
        }
        return 0;
      });
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>